/* import __COLOCATED_TEMPLATE__ from './add-from-template-mcp-server-modal.hbs'; */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* RESPONSIBLE TEAM: team-ml */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency-decorators';
import { inject as service } from '@ember/service';
import { post } from 'embercom/lib/ajax';
import { type TaskGenerator } from 'ember-concurrency';

interface Args {
  onModalClose: () => void;
}

export default class AddFromTemplateMcpServerModal extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare router: $TSFixMe;

  @tracked tokenValue = '';

  constructor(owner: unknown, args: Args) {
    super(owner, args);
  }

  @task({ drop: true })
  *addMcpServer(): TaskGenerator<void> {
    try {
      yield post('/ember/workflow_connector/setup_mcp_actions/add_mcp_server', {
        app_id: this.appService.app.id,
        server_name: 'Stripe', // TODO: make this depending on the integration selected
        token_value: this.tokenValue,
      });
      window.location.reload();
    } catch (error) {
      console.error('Error adding MCP server:', error);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::AddFromTemplateMcpServerModal': typeof AddFromTemplateMcpServerModal;
  }
}
